import {
    currentUserUsesClientSigning as currentUserUsesClientSigningFeature,
    hasClientSigningFeature,
} from 'lib/clientSigningFeature'

type UserFeature = string | { name?: string | null }

// Market availability is centralized here so callers do not inspect rollout data.
export function hasOrdinalsMarketFeature(_features?: UserFeature[] | null): boolean {
    return true
}

export { hasClientSigningFeature }

export function currentUserHasOrdinalsMarket(): boolean {
    return hasOrdinalsMarketFeature(window.gon?.currentUser?.features)
}

export function currentUserUsesClientSigning(): boolean {
    return currentUserUsesClientSigningFeature()
}

export function currentUserCanTradeOrdinals(): boolean {
    const features = window.gon?.currentUser?.features
    return !!window.gon?.currentUser?.id && hasOrdinalsMarketFeature(features)
}
